import { render, staticRenderFns } from "./PersonInfoBlock.vue?vue&type=template&id=08a51e0c&scoped=true&"
import script from "./PersonInfoBlock.vue?vue&type=script&lang=js&"
export * from "./PersonInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a51e0c",
  null
  
)

export default component.exports